<div class="summary">
  <h2 *ngIf="!accountOpened">{{ 'steps.id5.account_to_fund.funding_summary' | translate }}</h2>
  <ng-container>
    <div class="white-box bank-details" *ngIf="oneTimeInvested !== 0">
      <h4 [innerHTML]="'steps.id5.account_funded.intro_one_time' | translate"></h4>
      <div class="bank-details-items">
        <div class="bank-details-items-item">
          <p [innerHTML]="'steps.id5.account_funded.transfer_type' | translate"></p>
        </div>
        <div class="bank-details-items-item">
          <p>
            <b [innerHTML]="'steps.id5.account_funded.amount' | translate"></b> {{ currentAccountDetails.currency }}
            {{ oneTimeInvested | number }}
          </p>
        </div>
      </div>
    </div>
    <div class="white-box bank-details" *ngIf="monthlyInvested !== 0">
      <h4>
        <span [innerHTML]="'steps.id5.account_funded.intro_monthly' | translate"></span>
        <app-ui-tooltip [content]="'steps.id5.account_funded.tooltip_month' | translate" color="yellow" size="small"></app-ui-tooltip>
      </h4>
      <div class="bank-details-items">
        <div class="bank-details-items-item">
          <p [innerHTML]="'steps.id5.account_funded.transfer_type' | translate"></p>
        </div>
        <div class="bank-details-items-item">
          <p [innerHTML]="'steps.id5.account_funded.frequency' | translate"></p>
        </div>
      </div>
      <div class="bank-details-items">
        <div class="bank-details-items-item">
          <p [innerHTML]="'steps.id5.account_funded.point_in_time' | translate"></p>
        </div>
        <div class="bank-details-items-item">
          <p>
            <b [innerHTML]="'steps.id5.account_funded.amount' | translate"></b> {{ currentAccountDetails.currency }}
            {{ monthlyInvested | number }}
          </p>
        </div>
      </div>
      <small>
        <ng-container *ngIf="currentAccountDetails.kind !== '3a'; else show3ASavings">
          {{ 'reinvest.savings' | translate }}
        </ng-container>
        <ng-template #show3ASavings>
          {{ 'reinvest.savings_3a' | translate }}
        </ng-template>
      </small>
    </div>
  </ng-container>
  <div class="white-box bank-details" *ngIf="accountOpened">
    <h4 [innerHTML]="'steps.id5.account_funded.subtitle' | translate"></h4>
    <p class="bank-details-block">
      <b [innerHTML]="'steps.id5.saxo_funded.subject' | translate"></b><br />{{ customerData.first_name }}
      {{ customerData.last_name }}
    </p>
    <div class="bank-details-block">
      <p [innerHTML]="'steps.id5.saxo_funded.bank_name' | translate"></p>
      <p>{{ 'reinvest.bankAddress' | translate }}</p>
    </div>
    <p class="bank-details-block">
      <b>IBAN</b><br /><span *ngIf="iban">{{ iban }}</span>
    </p>
    <p class="bank-details-block"><b>SWIFT / BIC</b><br />{{ 'steps.id5.saxo_funded.swiftBic' | translate }}</p>
    <app-deposit-delay-info [addMargin]="false"></app-deposit-delay-info>
  </div>
</div>
